module.exports = __webpack_public_path__ + "img/mb-step-2.d86ea2a6.png";